import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Aria from 'formvalidation/es6/plugins/Aria';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';

export default function newsletterFormValidation() {
    const newsForm = document.querySelector('#newsletter-section form');

    if (newsForm) {
        const plugins = {
            trigger: new Trigger(),
            bootstrap3: new Bootstrap3(),
            defaultSubmit: new DefaultSubmit(),
            submitButton: new SubmitButton(),
            aria: new Aria(),
            declarative: new Declarative({
                html5Input: true,
            }),
        };
        if (document.getElementById('captcha_container')) {
            plugins.recaptcha = new Recaptcha({
                element: 'captcha_container',
                siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
                size: 'invisible',
                message: JSON.parse(document.querySelector('#newsletter_json_translations').innerHTML).reCaptchaErrorMessage,
            });
        }
        formValidation(newsForm, {
            plugins,
        });
        const formControl = newsForm.querySelectorAll('.form-control');

        [].forEach.call(formControl, (input) => {
            if (input.value !== '') {
                input.classList.add('not-empty');
                input.classList.remove('empty');
            }
            input.addEventListener('blur', function () {
                const tmpval = this.value;
                if (tmpval === '') {
                    this.classList.add('empty');
                    this.classList.remove('not-empty');
                } else {
                    this.classList.add('not-empty');
                    this.classList.remove('empty');
                }
            });
        });
    }
}
